import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from '../assets/images/un-logo.svg';
import Header from '../components/Header';
import Horario from '../components/Horario';
import Horariofiltros from '../components/Horario_filtros';
import Horariofiltroscoord from '../components/Horario_filtros_coord';
import Horariofiltrosopcion from '../components/Horario_filtros_opcion';
import Nrcinfo from '../components/Nrc_info';

import { getusercordinator } from '../services/login';


function Inicio() {
	const [selectcursos, setSelectcursos] = useState([]);
	const [cursokey, setCursokey] = useState(true);
	const [fecha, setFecha] = useState('');
	//const [filtrodias, setFiltrodias] = useState([]);
	//const [filtrohoras, setFiltrohoras] = useState([]);
	//const [filtrodiahora, setFiltrodiahora] = useState([]);
	const [bloqueos, setBloqueos] = useState([  [false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false],
												[false, false, false, false, false, false, false, false]]);
	const [tabla] = useState([  ['H-06:30-07:30', 'M-06:30-07:30', 'T-06:30-07:30', 'W-06:30-07:30', 'R-06:30-07:30', 'F-06:30-07:30', 'S-06:30-07:30', 'U-06:30-07:30'],
								['H-07:30-08:30', 'M-07:30-08:30', 'T-07:30-08:30', 'W-07:30-08:30', 'R-07:30-08:30', 'F-07:30-08:30', 'S-07:30-08:30', 'U-07:30-08:30'],
								['H-08:30-09:30', 'M-08:30-09:30', 'T-08:30-09:30', 'W-08:30-09:30', 'R-08:30-09:30', 'F-08:30-09:30', 'S-08:30-09:30', 'U-08:30-09:30'],
								['H-09:30-10:30', 'M-09:30-10:30', 'T-09:30-10:30', 'W-09:30-10:30', 'R-09:30-10:30', 'F-09:30-10:30', 'S-09:30-10:30', 'U-09:30-10:30'],
								['H-10:30-11:30', 'M-10:30-11:30', 'T-10:30-11:30', 'W-10:30-11:30', 'R-10:30-11:30', 'F-10:30-11:30', 'S-10:30-11:30', 'U-10:30-11:30'],
								['H-11:30-12:30', 'M-11:30-12:30', 'T-11:30-12:30', 'W-11:30-12:30', 'R-11:30-12:30', 'F-11:30-12:30', 'S-11:30-12:30', 'U-11:30-12:30'],
								['H-12:30-13:30', 'M-12:30-13:30', 'T-12:30-13:30', 'W-12:30-13:30', 'R-12:30-13:30', 'F-12:30-13:30', 'S-12:30-13:30', 'U-12:30-13:30'],
								['H-13:30-14:30', 'M-13:30-14:30', 'T-13:30-14:30', 'W-13:30-14:30', 'R-13:30-14:30', 'F-13:30-14:30', 'S-13:30-14:30', 'U-13:30-14:30'],
								['H-14:30-15:30', 'M-14:30-15:30', 'T-14:30-15:30', 'W-14:30-15:30', 'R-14:30-15:30', 'F-14:30-15:30', 'S-14:30-15:30', 'U-14:30-15:30'],
								['H-15:30-16:30', 'M-15:30-16:30', 'T-15:30-16:30', 'W-15:30-16:30', 'R-15:30-16:30', 'F-15:30-16:30', 'S-15:30-16:30', 'U-15:30-16:30'],
								['H-16:30-17:30', 'M-16:30-17:30', 'T-16:30-17:30', 'W-16:30-17:30', 'R-16:30-17:30', 'F-16:30-17:30', 'S-16:30-17:30', 'U-16:30-17:30'],
								['H-17:30-18:30', 'M-17:30-18:30', 'T-17:30-18:30', 'W-17:30-18:30', 'R-17:30-18:30', 'F-17:30-18:30', 'S-17:30-18:30', 'U-17:30-18:30'],
								['H-18:30-19:30', 'M-18:30-19:30', 'T-18:30-19:30', 'W-18:30-19:30', 'R-18:30-19:30', 'F-18:30-19:30', 'S-18:30-19:30', 'U-18:30-19:30'],
								['H-19:30-20:30', 'M-19:30-20:30', 'T-19:30-20:30', 'W-19:30-20:30', 'R-19:30-20:30', 'F-19:30-20:30', 'S-19:30-20:30', 'U-19:30-20:30']]);
	const [rol, setRol] = useState('');

	const estu_coord = () => {
		let coordinador = getusercordinator();

		if (rol === 'Coordinador') {
			return <Horariofiltroscoord
				selectcursos={selectcursos}
				setSelectcursos={setSelectcursos}
				cursokey={cursokey}
				setCursokey={setCursokey}
				fecha={fecha}
				setFecha={setFecha}
				bloqueos={bloqueos}
				setBloqueos={setBloqueos}
				tabla={tabla}
			/>
		}else if(rol === 'Estudiante'){
			return <Horariofiltros
				selectcursos={selectcursos}
				setSelectcursos={setSelectcursos}
				cursokey={cursokey}
				setCursokey={setCursokey}
				fecha={fecha}
				setFecha={setFecha}
				bloqueos={bloqueos}
				setBloqueos={setBloqueos}
				tabla={tabla}
			/>
		}

		if (coordinador === 'SI') {
			return <Horariofiltrosopcion
				rol={rol}
				setRol={setRol}
			/>
		} else {
			return <Horariofiltros
				selectcursos={selectcursos}
				setSelectcursos={setSelectcursos}
				cursokey={cursokey}
				setCursokey={setCursokey}
				fecha={fecha}
				setFecha={setFecha}
				bloqueos={bloqueos}
				setBloqueos={setBloqueos}
				tabla={tabla}
			//filtrodias = {filtrodias}
			//setFiltrodias = {setFiltrodias}
			//filtrohoras = {filtrohoras}
			//setFiltrohoras = {setFiltrohoras}
			//filtrodiahora = {filtrodiahora}
			//setFiltrodiahora = {setFiltrodiahora}
			/>
		}

		if (rol === 'Coordinador') {
			return <Horariofiltroscoord
				selectcursos={selectcursos}
				setSelectcursos={setSelectcursos}
				cursokey={cursokey}
				setCursokey={setCursokey}
				fecha={fecha}
				setFecha={setFecha}
				bloqueos={bloqueos}
				setBloqueos={setBloqueos}
				tabla={tabla}
			/>
		}else if(rol === 'Estudiante'){
			return <Horariofiltros
				selectcursos={selectcursos}
				setSelectcursos={setSelectcursos}
				cursokey={cursokey}
				setCursokey={setCursokey}
				fecha={fecha}
				setFecha={setFecha}
				bloqueos={bloqueos}
				setBloqueos={setBloqueos}
				tabla={tabla}
			/>
		}
	}
	return (
		<div>
			<Header />
			<Container>
				<Row>
					<img src={logo} className="logoprint" alt="Logo Universidad del Norte" />
				</Row>
				<Row>
					<Col className="horariofiltros" md={4}>
						{estu_coord()}
					</Col>
					<Col md={8}>
						<Horario
							selectcursos={selectcursos}
							setSelectcursos={setSelectcursos}
							cursokey={cursokey}
							setCursokey={setCursokey}
							bloqueos={bloqueos}
							setBloqueos={setBloqueos}
							tabla={tabla}
						//filtrodias = {filtrodias}
						//setFiltrodias = {setFiltrodias}	
						//filtrohoras = {filtrohoras}
						//setFiltrohoras = {setFiltrohoras}
						//filtrodiahora = {filtrodiahora}
						//setFiltrodiahora = {setFiltrodiahora}			
						/>
					</Col>
					<Col className="infoprint" md={3}>
						<Nrcinfo
							selectcursos={selectcursos}
							cursokey={cursokey}
							fecha={fecha}
						/>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default Inicio;